module.exports = __webpack_public_path__ + "static/media/66790008-ORf1wSgs.00e673dd.JPG";